<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">Quotation</h2>
      <br />
      <el-button style="float: right; margin-right: 30px" @click="Create()"
        >Create</el-button
      >
    </el-row>
    <br />
    <el-card>
      <el-row>
        <el-form
          :inline="true"
          :model="query"
          :label-position="'top'"
          class="demo-form-inline"
        >
          <el-col>
            <el-form-item label="Customer" prop="customer">
              <el-select
                v-model="query.customer"
                placeholder="Select"
                filterable
                allow-create
                @change="load"
                clearable
              >
                <el-option
                  v-for="item in customerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>

        <el-col>
          <el-button
            type="primary"
            @click="
              query.page = 1;
              load();
            "
            >Filter</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
        <el-col>
          <el-table
            v-loading="loading"
            :data="searchResult.quotations"
            class="border"
          >
            <el-table-column type="index" width="50" />
            <el-table-column prop="createdAt" label="createdAt">
              <template slot-scope="scope">
                {{ dayFormat(scope.row.createdAt) }}
              </template>
            </el-table-column>
            <el-table-column prop="customer" label="Customer">
              <template slot-scope="scope">
                {{ scope.row.customer.name }}
              </template>
            </el-table-column>
            <el-table-column
              prop="deliveryTimeWithMonth"
              label="Delivery Time (Month)"
            />
            <el-table-column label="infinity">
              <template slot-scope="scope">
                {{ productType("infinity", scope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="wired">
              <template slot-scope="scope">
                {{ productType("wired", scope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="sensewayLiteWired">
              <template slot-scope="scope">
                {{ productType("sensewayLiteWired", scope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="sensewayLiteInfinity">
              <template slot-scope="scope">
                {{ productType("sensewayLiteInfinity", scope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="cloudApp">
              <template slot-scope="scope">
                {{ productType("cloudApp", scope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="Total Price">
              <template slot-scope="scope">
                {{ totalPriceRow(scope.row.hardwares) }} USD
              </template>
            </el-table-column>
            <el-table-column label="Actions" width="200px">
              <template slot-scope="scope">
                <el-popover placement="left">
                  <p>Choose language?</p>
                  <div style="text-align: left; margin: 0">
                    <el-button
                      @click="PDF(scope, 'en')"
                      style="margin: 5px"
                      size="mini"
                      slot="reference"
                      >English PDF</el-button
                    >
                    <el-button
                      @click="PDF(scope, 'tr')"
                      style="margin: 5px"
                      size="mini"
                      slot="reference"
                      >Turkish PDF</el-button
                    >
                  </div>
                  <el-button slot="reference">PDF</el-button>
                </el-popover>
                <el-button
                  style="margin-left: 10px"
                  size="medium"
                  type="danger"
                  @click="Delete(scope)"
                  >Delete</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
      </el-row>
    </el-card>

    <el-dialog width="50%" title="Create Quotation" :visible.sync="showForm">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        v-loading="formLoading"
        label-width="30%"
      >
        <el-form-item label="Customer" prop="customer">
          <el-select
            v-model="form.customer"
            placeholder="Select"
            clearable
            filterable
            allow-create
          >
            <el-option
              v-for="item in customerSelect"
              :key="item.value"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Tecnical Service" prop="tecnicalService">
          <el-checkbox v-model="form.tecnicalService"></el-checkbox>
        </el-form-item>
        <el-form-item label="Integration" prop="integration">
          <el-checkbox v-model="form.integration"></el-checkbox>
        </el-form-item>
        <el-form-item
          label="Hourly Total in Tecnical Service"
          prop="tecnicalServiceTotalHourly"
        >
          <el-input-number
            placeholder="Please input"
            :min="0"
            size="mini"
            v-model="form.tecnicalServiceTotalHourly"
          />
        </el-form-item>
        <el-form-item
          label="Delivery Time with Month"
          prop="deliveryTimeWithMonth"
        >
          <el-input-number
            placeholder="Please input"
            size="mini"
            :min="0"
            v-model="form.deliveryTimeWithMonth"
          />
        </el-form-item>
        <el-form-item label="Validity Time with Day" prop="validityTimeWithDay">
          <el-input-number
            placeholder="Please input"
            size="mini"
            :min="0"
            v-model="form.validityTimeWithDay"
          />
        </el-form-item>
        <el-form-item
          label="Warranty Time with Year"
          prop="warrantyTimeWithYear"
        >
          <el-input-number
            placeholder="Please input"
            size="mini"
            :min="0"
            v-model="form.warrantyTimeWithYear"
          />
        </el-form-item>
        <el-form-item label="Payment Time With Day" prop="paymentWithDay">
          <el-input-number
            placeholder="Please input"
            size="mini"
            :min="0"
            v-model="form.paymentWithDay"
          />
          (Eğer 0 girerseniz peşin ödeme olacaktır)
        </el-form-item>
        <el-form-item label="Privacy Side" prop="privacySide">
          <p style="margin-top: 0px">
            Tarafınıza iletilen işbu doküman ............ sunulmuştur. Üçüncü
            kurum ya da kişiler ile paylaşılamaz.
          </p>
          <el-input placeholder="Please input" v-model="form.privacySide" />
        </el-form-item>
        <el-form-item label="Add Label">
          <el-button size="mini" @click="addItem()">Add</el-button>
        </el-form-item>
        <el-table
          v-loading="loading"
          :data="form.hardwares"
          class="border"
          :max-height="500"
        >
          <el-table-column type="index" width="50" />
          <el-table-column prop="product" label="Product Type" width="200px;">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.product"
                placeholder="Please input product"
                clearable
                filterable
                allow-create
              >
                <el-option
                  v-for="item in hardwaresType"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="quantity	" label="Quantity" width="200px;">
            <template slot-scope="scope">
              <el-input-number
                placeholder="Please input quantity"
                v-model="scope.row.quantity"
                :controls="false"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="Price" width="200px;">
            <template slot-scope="scope">
              <el-input-number
                placeholder="Please input price"
                v-model="scope.row.price"
                :controls="false"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="Total Price" width="100px;">
            <template slot-scope="scope">
              {{ scope.row.quantity * scope.row.price }}
            </template>
          </el-table-column>
          <el-table-column label="Actions" width="100px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="deleteGoods(scope.row)"
                >Delete</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="Total">
          {{ totalPrice() }} USD
          <em class="el-icon-money"></em>
          <em v-if="totalPrice() >= 100 && totalPrice() < 1000">
            Rakı parası çıktı</em
          >
          <em v-if="totalPrice() >= 1000 && totalPrice() < 5000"
            >Bu ay rahatız</em
          >
          <em v-if="totalPrice() >= 5000 && totalPrice() < 10000"
            >Umarım kabul ederler</em
          >
          <em v-if="totalPrice() >= 10000">Yapıyoruz bişiiiler</em>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="CreateQuotation()"
            >Create</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import beautify from "json-beautify";
import moment from "moment";
import dayjs from "dayjs";
import axios from "axios";
import { url } from "../service/url";

export default {
  name: "Quotation",
  components: {},
  data() {
    return {
      query: {
        customer: "",
        page: 1,
        pageSize: 10,
      },
      pageSizes: [10, 25, 50, 75],
      customerSelect: [],
      editId: "",
      showForm: false,
      formLoading: false,
      certs: {},
      showCertsForm: false,
      languageSelect: [
        {
          label: "Turkish",
          value: "tr",
        },
        {
          label: "English",
          value: "en",
        },
      ],
      hardwaresType: [
        "infinity",
        "wired",
        "anchor",
        "sensewayLiteInfinity",
        "sensewayLiteWired",
        "sensewayLiteAnchor",
        "cloudApp",
      ],
      hardwaresIndex: 0,
      form: {
        customer: "",
        tecnicalService: false,
        integration: false,
        hardwares: [
          {
            index: 0,
            product: "",
            quantity: 0,
            price: 0,
          },
        ],
        tecnicalServiceTotalHourly: 0,
        deliveryTimeWithMonth: 1,
        validityTimeWithDay: 15,
        warrantyTimeWithYear: 1,
        paymentWithDay: 0,
        privacySide: "",
        language: "",
      },
      rules: {
        customer: [
          {
            required: true,
            message: "Please select customer",
            trigger: "blur",
          },
        ],
        tecnicalServiceTotalHourly: [
          {
            required: true,
            message: "please type tecnical service total hourly",
            trigger: "blur",
          },
        ],
        deliveryTimeWithMonth: [
          {
            required: true,
            message: "please type delivery time with month",
            trigger: "blur",
          },
        ],
        validityTimeWithDay: [
          {
            required: true,
            message: "please type validity time with day",
            trigger: "blur",
          },
        ],
        warrantyTimeWithYear: [
          {
            required: true,
            message: "Please choose warranty time with year",
            trigger: "blur",
          },
        ],
        privacySide: [
          {
            required: true,
            message: "Please type customer for privacy side",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getQuotations(this.query);
    this.getPartners();
    var urlString = `${url}/customer`;
    axios.get(urlString).then((res) => {
      this.customerSelect = res.data.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    });
  },
  computed: {
    ...mapState("quotation", ["searchResult", "loading"]),
    ...mapState("partner", ["customers", "partners"]),
    customerFilterSelect() {
      return this.customers.map((x) => {
        return {
          value: x._id,
          text: x.name,
        };
      });
    },
    faultTypeNames() {
      return this.searchResultFaultTypes.faultTypes.map((x) => {
        return x._id;
      });
    },
  },
  methods: {
    ...mapActions("quotation", [
      "getQuotations",
      "createQuotation",
      "getQuotationHTML",
      "deleteQuotation",
    ]),
    ...mapActions("customer", ["getPartners"]),
    dayFormat(createdAt) {
      return dayjs(createdAt).format("DD-MM-YYYY HH:mm:ss");
    },
    totalPriceRow(hardwares) {
      let totalPrice = 0;
      for (let i = 0; i < hardwares.length; i++) {
        totalPrice += hardwares[i].quantity * hardwares[i].price;
      }
      return totalPrice;
    },
    PDF(scope, language) {
      this.getQuotationHTML({ _id: scope.row._id, language: language }).then(
        (html) => {
          this.printNow(html);
        }
      );
    },
    infoJson(row) {
      return `${beautify(row, null, 5)}`;
    },
    productType(type, row) {
      let arr = row.hardwares.filter((x) => x.product == type);
      return arr.length == 0 ? 0 : arr[0].quantity;
    },
    totalPrice() {
      let total = 0;
      this.form.hardwares.map((x) => {
        total = total + x.quantity * x.price;
      });
      return total;
    },
    addItem() {
      this.form.hardwares.push({
        index: ++this.hardwaresIndex,
        product: "",
        quantity: 0,
        price: 0,
      });
    },
    deleteGoods(scope) {
      let index = this.form.hardwares.findIndex((x) => x.index == scope.index);
      this.form.hardwares.splice(index, 1);
    },
    load() {
      this.getQuotations(this.query);
    },
    adviseSystemAdmin() {
      this.$message.info("advise to the system admin");
    },
    CreateQuotation() {
      this.$confirm("Are you sure?", "Warning", {
        confirmButtonText: "Yes, send",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.formLoading = true;
            return this.createQuotation({
              ...this.form,
            })
              .then(() => {
                this.showForm = false;
                this.formLoading = false;
                this.load();
              })
              .catch((e) => {
                this.$message.error(e.toString());
              });
          }
        });
      });
    },
    printNow(prtHtml) {
      // Get all stylesheets HTML
      // let stylesHtml = "";
      // for (const node of [
      //   ...document.querySelectorAll('link[rel="stylesheet"], style'),
      // ]) {
      //   stylesHtml += node.outerHTML;
      // }

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(prtHtml);
      WinPrint.document.title = `${moment().format("DD-MM-YYYY HH:mm:ss")}`;
      WinPrint.document.close();
      WinPrint.focus();

      WinPrint.onload = () => {
        WinPrint.print();
      };
    },
    Delete(scope) {
      this.$confirm(
        "This will permanently delete the Fault Report. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => this.deleteQuotation(scope.row._id))
        .then(() => this.getQuotations(this.query))
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    copyIdToClipboard(id) {
      this.$clipboard(id);
      this.$message.info("'" + id + "' " + "copy to clipboard success");
    },
    Create() {
      this.editId = undefined;
      this.showForm = true;
    },
    Cancel() {
      this.editId = "";
      this.form = {
        customer: "",
      };
    },
    Edit(scope) {
      this.form = {
        customer: scope.row.customer,
      };
      this.editId = scope.row._id;
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
abbr {
  max-width: 150px;
  word-break: initial;
}
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>